import React from 'react';
import PropTypes from 'prop-types';

import styles from './HeaderIcon.scss';

const HeaderIcon = ({ source }) => {
  return <img className={styles.icon} src={source} alt="" />;
};

HeaderIcon.propTypes = {
  source: PropTypes.string.isRequired
};

export default HeaderIcon;
